import React, { FunctionComponent, HTMLAttributes, useEffect, useState } from 'react';
import Button from '../button/button-component';
import styles from './button-toggle-component.module.scss';

export type ButtonToggleProps = {
  items: { text: string; id: string }[];
  // Id of the selected item
  value?: string;
  disabled?: boolean;
  valueChangedCallback?: (key: string) => void;
} & HTMLAttributes<HTMLDivElement>;

/**
 * Button Toggle
 *
 * https://www.figma.com/design/gen9UN3Pqlw5ZaKLoudGSt/My-Account?node-id=1060-31840&t=rCQnsvQ6UHBLdnk5-4
 */
export const ButtonToggle: FunctionComponent<ButtonToggleProps> = (props: ButtonToggleProps) => {
  const { items, value, disabled, className, valueChangedCallback, ...divAttributes } = props;

  const [selected, setSelected] = useState(value ?? items[0].id);

  useEffect(() => {
    setSelected(value ?? items[0].id);
  }, [items, value]);

  return (
    <div className={`${styles.container} ${className ?? ''}`} {...divAttributes}>
      {items.map(({ text, id }) => {
        return (
          <Button
            key={id}
            id={id}
            text={text}
            className={styles.button}
            buttonType={id === selected ? 'primary' : 'outline'}
            onClick={() => onClick(id)}
            disabled={disabled}
            data-testid={id}
          />
        );
      })}
    </div>
  );

  function onClick(key: string) {
    setSelected(key);
    valueChangedCallback && valueChangedCallback(key);
  }
};

export default ButtonToggle;
